"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketingTrafficHook = void 0;
class MarketingTrafficHook {
    constructor() {
        this._allowedPidList = [
            // cuizhengyang.1@bytedance.com
            'google_sem',
            // wangqian.4012@bytedance.com
            'US_pinterest',
            'JP_pinterest',
        ];
        this._paramsList = [
            // appsflyer
            'pid',
            'c',
            'af_prt',
            'clickid',
            'af_siteid',
            'af_sub_siteid',
            'af_c_id',
            'af_adset',
            'af_adset_id',
            'af_ad',
            'af_ad_id',
            'af_click_lookback',
            'af_channel',
            'af_keywords',
            // iOS - specific
            'sha1_idfa',
            'af_ios_store_cpp',
            // others
            'target',
            'tracking',
            'appid',
            'timestamp',
            'placement',
        ];
    }
    onActive(oneLink) {
        const href = new URL(location.href);
        const pid = href.searchParams.get('pid');
        if (!pid || !this._allowedPidList.includes(pid)) {
            return;
        }
        this._paramsList.forEach((parameter) => {
            const value = href.searchParams.get(parameter);
            if (value) {
                oneLink.searchParams.set(parameter, value);
            }
        });
    }
}
exports.MarketingTrafficHook = MarketingTrafficHook;
